<template>
  <resource
    class="flex-grow-1"
    resource="moderator"
    resourceName="Moderator"
    :original="moderator"
    :attributes="attributes"
  >
    <div slot="title">
      <h4>Moderator bearbeiten</h4>
    </div>
  </resource>
</template>

<script lang="babel">
export default {
  props: {
    moderator: {
      required: true,
      type: Object
    }
  },
  computed: {
    isAdmin() {
      return this.$store.getters['user/meHasRole']('admin');
    },
    attributes() {
      let attributes = [
        {
          name: 'name',
          label: 'Name',
        },
        {
          name: 'email',
          label: 'E-Mail-Adresse',
        },
        {
          name: 'id',
          label: 'Passwort',
          type: 'PasswordResetSelector',
        },
        {
          name: 'moderator_profile|asa_only',
          label: 'Nur ASA schreiben',
          type: 'CheckboxSelector',
        },
        {
          name: 'moderator_profile|min_chars_for_messages',
          label: 'Standard Wert für x Zeichen pro Nachricht',
          type: 'DefaultValueSwitchSelector',
        },
        {
          name: 'moderator_profile|min_chars_for_asa',
          label: 'Standard Wert für x Zeichen pro asa Nachricht',
          type: 'DefaultValueSwitchSelector',
        }

      ];

      if (this.isAdmin) {
        attributes.push(
          {
            name: 'moderator_profile|agency_id',
            label: 'Agency',
            type: 'DropdownSelector',
            items: this.agencies
          }
        );
      }

      return attributes;
    }
  },
  methods: {
    getAgencies() {
      return this.$http
        .get("/api/v1/agency/agencyListRead")
        .then(({ data }) => {
          for (const [value, text] of Object.entries(data)) {
            this.agencies.push({ value: value, text: value + " - " + text });
          }
        });
    }
  },
  created() {
    if (this.isAdmin) {
      this.getAgencies();
    }
  },
  data() {
    return {
      agencies: [],
    }
  }
};
</script>
